import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	settings: {
		defaultMessage: 'Settings',
		id: 'atlassian-navigation.settings.menu.settings',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: 'Settings',
	},
});
